// Pinned-coach list stored in localStorage with event bus for cross-component sync.
const KEY = "earnit_pinned_coaches";
const EVT = "earnit:pins-changed";

export const getPinned = () => {
    try {
        return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch {
        return [];
    }
};

export const setPinned = (ids) => {
    localStorage.setItem(KEY, JSON.stringify(ids));
    window.dispatchEvent(new CustomEvent(EVT));
};

export const togglePin = (id, max = 3) => {
    const list = getPinned();
    const idx = list.indexOf(id);
    if (idx >= 0) {
        list.splice(idx, 1);
    } else {
        if (list.length >= max) return { ok: false, reason: "max" };
        list.push(id);
    }
    setPinned(list);
    return { ok: true, pinned: list };
};

export const subscribePinned = (cb) => {
    const h = () => cb(getPinned());
    window.addEventListener(EVT, h);
    window.addEventListener("storage", h);
    return () => {
        window.removeEventListener(EVT, h);
        window.removeEventListener("storage", h);
    };
};
